import type { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch';

export const toggleSwitchPreset: ToggleSwitchDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: '{nspSlate.800}',
        hoverBackground: '{nspSlate.800}',
        checkedBackground: '{nspSky.500}',
        checkedHoverBackground: '{nspSky.300}',
        borderColor: '{nspSlate.200}',
        hoverBorderColor: '{nspSlate.200}',
        checkedBorderColor: '{nspSky.500}',
        checkedHoverBorderColor: '{nspSky.300}',
      },
      handle: {
        background: '{nspSlate.200}',
        hoverBackground: '{nspSlate.200}',
        checkedBackground: '{nspSlate.0}',
        checkedHoverBackground: '{nspSlate.0}',
      },
    },
    light: {
      root: {
        background: '#cbd5e1',
        hoverBackground: '#94a3b8',
        checkedBackground: '{nspOcean.400}',
        checkedHoverBackground: '{nspOcean.300}',
        borderColor: '#cbd5e1',
        hoverBorderColor: '#94a3b8',
        checkedBorderColor: '{nspOcean.400}',
        checkedHoverBorderColor: '{nspOcean.300}',
      },
      handle: {
        background: '{nspSlate.0}',
        hoverBackground: '{nspSlate.0}',
        checkedBackground: '{nspSlate.0}',
        checkedHoverBackground: '{nspSlate.0}',
      },
    },
  },
};
